import { __awaiter, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
/**
 * Call the init endpoint of business.bing.com to warmup answer calls
 */
export function warmupMsb(options) {
    return __awaiter(this, void 0, void 0, function () {
        var searchPrefetch, searchSettings, _a, prefetch, tokenProviders, searchEnvironment, searchConfig, bingTokenProvider, fastBingAnswerResultsEnabled;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchPrefetch = options.searchPrefetch, searchSettings = options.searchSettings;
                    return [4 /*yield*/, Promise.all([
                            searchPrefetch.getModule(),
                            searchSettings.getTokenProviders(),
                            searchSettings.getSearchEnvironment(),
                            searchSettings.getSearchConfig(),
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 4]), prefetch = _a[0], tokenProviders = _a[1], searchEnvironment = _a[2], searchConfig = _a[3];
                    bingTokenProvider = tokenProviders.bingTokenProvider;
                    fastBingAnswerResultsEnabled = searchConfig.fastBingAnswerResultsEnabled;
                    return [2 /*return*/, queryCache.fetchQuery('SearchWarmupMSB', function () {
                            return prefetch.warmupMsb({
                                token: '',
                                clientType: 'OfficeSharePoint',
                                msbUrl: prefetch.resolveBingUrl(searchEnvironment),
                                tokenProvider: bingTokenProvider,
                            });
                        }, {
                            cacheTime: Infinity,
                            staleTime: Infinity,
                            enabled: !!fastBingAnswerResultsEnabled,
                        })];
            }
        });
    });
}
//# sourceMappingURL=warmupMsb.js.map